import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../auth-context";
import Restricted from "../widget/restricted";

export default function Header() {
  const authenticationContext = useContext(AuthContext)!;

  return (
    <>
      <div id="menu">
        <img src="/favicon.svg" height="30px" />
        <span style={{ flexGrow: 1 }}></span>
        <Restricted to="profile">
          <Link id="menu_home" to="/home" className="action">
            <img src="/static/img/home.gif" height="20px" />
            Home
          </Link>
          <button
            id="menu_logout"
            className="action"
            onClick={authenticationContext.logout}
          >
            <img src="/static/img/logout.gif" height="20px" />
            Logout
          </button>
          <span>
            {authenticationContext.authenticatedData?.user.group == "cdc" &&
              "🧑‍🦽"}
            {authenticationContext.authenticatedData?.user.group == "manager" &&
              "🧑‍💼"}
            {authenticationContext.authenticatedData?.user.group == "admin" &&
              "🧑‍💻"}
            {authenticationContext.authenticatedData?.user.name} ({" "}
            {authenticationContext.authenticatedData?.user.username} )
          </span>
        </Restricted>
      </div>
      {/* ANY-1122
      {authenticationContext.authenticatedData && (
        <>
          {criticityEqualOrAbove(
            authenticationContext.authenticatedData.user.profile_criticity!,
            "WARNING"
          ) && (
            <div
              className={`alert alert-${criticityToCSS(authenticationContext.authenticatedData.user.profile_criticity)}`}
            >
              Your profile data is outdated. Please review and update it here:{" "}
              <Link to="/profile">Profile</Link>
            </div>
          )}
          {criticityEqualOrAbove(
            authenticationContext.authenticatedData.user.password_criticity!,
            "WARNING"
          ) && (
            <div
              className={`alert alert-${criticityToCSS(authenticationContext.authenticatedData.user.password_criticity)}`}
            >
              Your password is outdated. Please change it here:
              <Link to="/profile/password">Change Password</Link>
            </div>
          )}
        </>
      )} */}
    </>
  );
}
